var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMResguardo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#2eccb6;}.cls-3{fill:#329be6;}.cls-4{fill:#0b5c96;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_resguardo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resguardo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.23,37.6,28.4,34.77l-7.32,7.32a6,6,0,0,0-8,8l4-4,2.82,2.83-4,4a6,6,0,0,0,8-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.91,15.92l-4,4-2.83-2.83,4-4a6,6,0,0,0-8,8L34.77,28.4l2.83,2.83,7.33-7.33a6,6,0,0,0,8-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.68,50.67h0a2,2,0,0,1-2.83,0L21,23.8,23.81,21,50.68,47.84A2,2,0,0,1,50.68,50.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.81,17.44l0,0L22,19.19,19.2,22,17.71,23.5a.42.42,0,0,0,0,.57l1.49,1.48.72.72L16.39,29.8,8.61,22l3.53-3.53,2.19,2.19a.42.42,0,0,0,.57,0l9.37-9.37a4,4,0,0,1,5.65,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.42,39.22,26.64,33l-4.95-5-5,5a.4.4,0,0,1-.56,0L8,25,.28,32.72a.4.4,0,0,0,0,.56L10.83,43.83l.06-.12A8.51,8.51,0,0,1,20.42,39.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.69,9.55,33.18,11a.4.4,0,0,1,0,.56l-7.6,7.6L33,26.63l6.22-6.22a8.51,8.51,0,0,1,4.48-9.53l.12-.05L33.28.28a.4.4,0,0,0-.56,0L25,8a5.68,5.68,0,0,1,1.52-.34A6.44,6.44,0,0,1,31.69,9.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,39.36l-6.23,6.23a8.52,8.52,0,0,1-2.26,7.92,8.75,8.75,0,0,1-2.35,1.66L32.72,65.72a.4.4,0,0,0,.56,0L46.35,52.65c-.09-.07-.18-.13-.27-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72,55.17,22.17a8.51,8.51,0,0,1-9.58,4.61L39.37,33,52.45,46.08a2.65,2.65,0,0,1,.21.26L65.72,33.28A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.53,12.86a.39.39,0,0,1,.13.65l-1.57,1.58,2.83,2.83,1.57-1.58a.39.39,0,0,1,.65.13,6,6,0,0,1,.09,3.76l1.94,1.94A8.5,8.5,0,0,0,43.83,10.83l1.94,1.94A6,6,0,0,1,49.53,12.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.68,50.67a2,2,0,0,1-2.56.21l-1.77,1.77a4.47,4.47,0,0,0,6.31-6.31l-1.77,1.77A2,2,0,0,1,50.68,50.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.61,22l3.53-3.53,1.18,1.18L25,8a7.2,7.2,0,0,0-2.65,1.71l-7.71,7.7-2.19-2.19a.42.42,0,0,0-.57,0l-6.5,6.5a.42.42,0,0,0,0,.57L8,25l1.76-1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.48,53.14a.4.4,0,0,1-.13-.66l1.57-1.56-2.83-2.83-1.57,1.57a.39.39,0,0,1-.65-.13,6,6,0,0,1-.1-3.76l-1.94-1.94A8.51,8.51,0,0,0,22.17,55.17l-1.94-1.94A6.08,6.08,0,0,1,16.48,53.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 47.1,
    y: 15.5,
    width: 2.82,
    height: 4,
    transform: "translate(1.83 39.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16.09,
    y: 46.5,
    width: 2.83,
    height: 4,
    transform: "translate(-29.17 26.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.37,33l6.22-6.22a8.51,8.51,0,0,0,9.58-4.61l-1.94-1.94a5.94,5.94,0,0,1-8.31,3.68L37.6,31.23,34.77,28.4l7.32-7.32a6,6,0,0,1,1.17-6.82,5.8,5.8,0,0,1,2.51-1.49l-1.94-1.94-.12.05a8.51,8.51,0,0,0-4.48,9.53L33,26.63,25.58,19.2l7.6-7.6a.4.4,0,0,0,0-.56L31.69,9.55A6.44,6.44,0,0,0,26.5,7.68,5.68,5.68,0,0,0,25,8L13.32,19.68l1,1a.4.4,0,0,0,.56,0l9.37-9.37a4,4,0,0,1,5.65,0l-6.11,6.12,0,0L22,19.19,19.2,22,17.71,23.5a.42.42,0,0,0,0,.57l1.49,1.48.72.72L16.39,29.8l-6.6-6.59L8,25l8.08,8.09a.4.4,0,0,0,.56,0l5-5,4.95,5-6.22,6.22a8.51,8.51,0,0,0-9.53,4.49l-.06.12,1.94,1.94a6,6,0,0,1,8.32-3.68l7.32-7.33,2.83,2.83-7.32,7.33a6,6,0,0,1-3.69,8.31l1.94,1.94a8.75,8.75,0,0,0,2.35-1.66,8.52,8.52,0,0,0,2.26-7.92L33,39.36,46.08,52.44c.09.08.18.14.27.21l1.77-1.77a1.78,1.78,0,0,1-.27-.21L21,23.8,23.81,21,50.68,47.84a1.39,1.39,0,0,1,.21.27l1.77-1.77a2.65,2.65,0,0,0-.21-.26Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMResguardo);
export default __webpack_public_path__ + "static/media/m_resguardo.b6f45e685dac40807904187508d9c76e.svg";
export { ForwardRef as ReactComponent };